module.exports = __webpack_public_path__ + "images/emoji/suspect.95088365e3afa9942578.png";